import { render, staticRenderFns } from "./NewInternetOfferTile.vue?vue&type=template&id=12ec6f62&scoped=true&"
import script from "./NewInternetOfferTile.vue?vue&type=script&lang=js&"
export * from "./NewInternetOfferTile.vue?vue&type=script&lang=js&"
import style0 from "./NewInternetOfferTile.vue?vue&type=style&index=0&id=12ec6f62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ec6f62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12ec6f62')) {
      api.createRecord('12ec6f62', component.options)
    } else {
      api.reload('12ec6f62', component.options)
    }
    module.hot.accept("./NewInternetOfferTile.vue?vue&type=template&id=12ec6f62&scoped=true&", function () {
      api.rerender('12ec6f62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/orange/broadband/internet/showcase/components/NewInternetOfferTile.vue"
export default component.exports